import React from 'react'
import styled from 'styled-components'
import { media } from 'styles/media'
import { useMediaQueryContext } from 'contexts/MediaQueryContext'

import { ParagraphMd } from 'components/display/Typography'
import { SectionTitle, SectionSubtitle } from 'pages/static/section'
import { LargeVideo } from 'components/branding/VideoBanner'
import BaseContainer from 'components/layout/Container'
import { HeaderCentered } from '../styles'

const Paragraph = styled(ParagraphMd)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;

  ${media.md`
    margin-top: 60px;
 `}
`

const OurPurpose = () => {
  const { md: largerThanMd } = useMediaQueryContext()

  return (
    <>
      <HeaderCentered>
        <SectionTitle>Our purpose</SectionTitle>
        <SectionSubtitle>
          Inspiring travellers to find fulfilling moments in nature
        </SectionSubtitle>
      </HeaderCentered>

      <BaseContainer width={980} noPadding>
        <LargeVideo height={largerThanMd ? '580px' : '400px'} />
      </BaseContainer>

      <Paragraph>
        <strong>Riparide</strong> exists to inspire travellers to unplug from
        modern-day trappings and find fulfillment in nature.
        <br />
        <br />
        It all started with a big city battle. Co-founder Marlon Law grew up in
        the mountains and by the ocean, but he lost that connection with nature
        when he moved to the city. Soon Marlon realised that nature was the
        perfect antidote to his urban lifestyle, so he set up a glamping tent
        and in doing so, Riparide got its first Story, documented by a local
        photographer. Marlon saw Storytelling as a creative way to bring to life
        the experience the tent offered, and Riparide was born.
        <br />
        <br />
        Riparide is now available in Australia, New Zealand and USA, with
        thousands of listings, delivering fulfilling moments to our travellers.
      </Paragraph>
    </>
  )
}

export default OurPurpose
